import * as request from "@/utils/request";
import { DefaultConfigs, inApp } from "@/common/js/constant";
import { setCommonAttrs, trackEvent } from "@/utils/omega";
import BusinessVerify, { EnumBusinessFlow } from "@/components/BusinessVerify";
import APP from "@/utils/app";
import { RISK_SDK_VERSION } from "@/components/RiskVerify/constants";

const baseUrl = `${DefaultConfigs.publicAPIPath}`;

export type IAnnualTaxInfo = {
  title: string;
  desc: string;
  content: Array<string>;
  previewDesc: string;
  confirmButton: {
    text: string;
  };
  button: {
    text: string;
  };
};

// 查询协议
export function queryAnnualTaxInfo(): Promise<IAnnualTaxInfo> {
  return request.post<IAnnualTaxInfo>(`${baseUrl}/sofipo/v0/bill/yearlyPage`, {});
}

// 获取pdf地址的响应
export type QueryDataRes = {
  // 场景一：命中核验
  // 是否需要业务核验 0:不需要 1:需要
  needBussVerify?: number;
  status?: number; // 转账状态
  tradeId?: string; // 转账ID
  tradeDetailURL?: string; // 转账详情URL
  verify_data?: string; // 风控核验码
  verify_session_id?: string; // 风控核验码
  verifySdkVersion?: string; // 风控核验版本号
  // 场景二：核验完成获取地址
  address?: string;
};

// 获取pdf地址的请求参数
export type PdfInfoReq = {
  // 账单周期
  billingCycle: string;
  // 核验会话 session id
  sessionId?: string;
  verifyInfo: {
    verifySdkVersion?: string; // 核验SDK版本号
    sessionId?: string;
    bussVerify: number; // 是否核验下发 0:否  1:是
    bioFlag?: number; // 生物识别能力
  };
};

// 获取银行账单pdf地址
export const queryPdfAddress = async (params: PdfInfoReq): Promise<QueryDataRes> => {
  // 核验版本
  params.verifyInfo = params.verifyInfo || {
    verifySdkVersion: RISK_SDK_VERSION,
  };
  try {
    return await request.post<QueryDataRes>(`${baseUrl}/sofipo/v0/bill/queryPdfAddress`, params);
  } catch (ret: any) {
    // 业务核验
    if (ret.errno === request.ERROR_TYPE.BusinessVerify) {
      // 核验拉起时禁止返回按钮
      if (inApp) {
        APP.requestBackPressedControl(() => {});
      }
      // 设置公参
      setCommonAttrs({
        // scene_source
        // 场景来源
        // 0-风控
        // 1-业务
        scene_source: BusinessVerify.scene,
        // from_source 流程来源
        from_source: EnumBusinessFlow.bankStatementYearly,
      });

      // 拉起核验
      return new BusinessVerify()
        .verify(JSON.parse(ret?.data?.bussVerifyResultInfo)?.atoDomain)
        .then((res) => {
          // 重置公参
          setCommonAttrs({
            // scene_source
            // 场景来源
            // 0-风控
            // 1-业务
            scene_source: undefined,
            // from_source 流程来源
            from_source: undefined,
          });
          // 释放控制
          if (inApp) {
            APP.cancelBackPressedControl();
          }
          // 增加核验token
          if (params.verifyInfo) {
            params.verifyInfo.sessionId = res.verify_session_id;
            // 核验完成
            params.verifyInfo.bussVerify = 1;
            params.sessionId = res.verify_session_id;
          }
          // 重新发起请求
          return queryPdfAddress(params);
        })
        .catch((err) => {
          // 释放控制
          if (inApp) {
            APP.cancelBackPressedControl();
          }
          // 技术打点
          trackEvent("tech_sofi_catch_error", {
            source: "bankStatement.annualTax.BusinessVerify",
            data: JSON.stringify(ret.name + ret.message || ret),
          });
          // 交给上层catch
          return Promise.reject(err);
        });
    }
    // 释放控制
    if (inApp) {
      APP.cancelBackPressedControl();
    }

    // 技术打点
    trackEvent("tech_sofi_catch_error", {
      source: "bankstatement.annualTax.queryPdfAddress",
      data: JSON.stringify(ret.name + ret.message || ret),
    });

    // 交给上层catch
    return Promise.reject(ret);
  }
};
